const m = require('air-vue-model')()
m.url = 'promos'
m.name = 'promo'
m.setPagination({
  page_size: 'all'
})
m.text = {
  itemTitle: 'Акция',
  listTitle: 'Акции'
}
m.default = {
  id: null,
  name: '',
  description: '',
  image: null,
  square_image: null,
  wide_image: null,
  sorting: 1,
  active: true,
  products: [],
  outlets: [],
  story_slides: [
    {
      position: 0,
      media_type: null,
      image: null,
      video: null,
      button_text: null,
      button_color: '#FFFFFF',
      action_type: 2,
      action_product: null
    },
    {
      position: 1,
      media_type: null,
      image: null,
      video: null,
      button_text: null,
      button_color: '#FFFFFF',
      action_type: 2,
      action_product: null
    },
    {
      position: 2,
      media_type: null,
      image: null,
      video: null,
      button_text: null,
      button_color: '#FFFFFF',
      action_type: 2,
      action_product: null
    },
    {
      position: 3,
      media_type: null,
      image: null,
      video: null,
      button_text: null,
      button_color: '#FFFFFF',
      action_type: 2,
      action_product: null
    }
  ]
}
m.routes = [
  {
    name: 'list',
    component: require('@/admin/views/promos/PromoList')
  },
  {
    name: 'item',
    component: require('@/admin/views/promos/PromoItem'),
    single: true
  }
]

m.pickupTypes = [
  {
    value: 1,
    label: 'Доставка'
  },
  {
    value: 2,
    label: 'Кафе'
  },
  {
    value: 9,
    label: 'Все заказы'
  }
]

module.exports = m
